import { WarehouseModelType } from '@teinor/erp/types/company/warehouse'
import { ComponentWithPermissions } from '../../../../../../../../baseComponents/CreateRoutering/types'
import SingleFormLayout from '../../../../../../../../baseComponents/Layout/SingleFormLayout'
import { FormRender } from '../../../../../../../../forms/FormRenderer/types'
import { getDictionaryStates } from '../../../../../../../../utils/globals/countries'
import { valueOrDefaultValue } from '../../../../../../../../utils/globals/valueOrDefaultValue'
import useCountryState from '../../../../../../../../utils/hooks/useCountry'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { getDictionaryCountries } from '../../../../../../../../utils/reducers/getters'
import { sortCountries } from '../../../../../../../../utils/globals/sortCountries'


interface MainWarehouseProps extends ComponentWithPermissions {
    basicData: WarehouseModelType | null
    getData: () => Promise<void>
}

const MainWarehouse: React.FC<MainWarehouseProps> = ({ basicData, userPermissions, getData}) => {
    const { t } = useTwinTranslation()
    const { country, setCountry } = useCountryState({defaultCountry: basicData?.country })

    const fields: FormRender<WarehouseModelType> = [
        {
            cols: 2,
            title: t('mainInformation', 'Información principal'),
            elements: [
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true
                },
                {
                    name: 'code',
                    label: t('code', 'Código'),
                    component: 'InputWithLabelMarginIntegerStateFull',
                },
                {
                    name: 'sales_representative',
                    label: t('salesRepresentative', 'Ventas a representante'),
                    component: 'CheckboxMargin',
                },
                {
                    name: 'stock_valid',
                    label: t('stocksValid', 'Validar Stock'),
                    component: 'CheckboxMargin',
                },
                {
                    name: 'not_inventories',
                    label: t('notInventories', 'Sin inventarios'),
                    component: 'CheckboxMargin',
                },
                {
                    name: 'blocked_inventory',
                    label: t('blockedInventory', 'Inventario bloqueado'),
                    component: 'CheckboxMargin',
                },
                {
                    name: 'id',
                    component: 'InputHidden'
                }
            ],
        },
        {
            cols: 2,
            title: t('address', 'Dirección'),
            elements: [
                {
                    name: 'address',
                    label: t('address', 'Dirección'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'additional_address',
                    label: t('number', 'Número'),
                    component: 'InputWithLabelMargin',
                    type: 'text'
                },
                {
                    name: 'postal_code',
                    label: t('postal_code', 'Código Postal'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'city',
                    label: t('city', 'Ciudad'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'country',
                    label: t('country', 'País'),
                    component: 'CustomSelectWithSearchBar',
                    items: getDictionaryCountries(),
                    sortFunction: sortCountries,
                    onChange: (value: string) => setCountry(value),
                    required: true
                },
                {
                    name: 'state',
                    label: t('state', 'Provincia'),
                    component: 'CustomSelectWithSearchBar',
                    sortItems: true,
                    items: getDictionaryStates(country),
                }
            ]
        },
    ]
    const parsedFields = valueOrDefaultValue(fields, userPermissions, basicData)

    return (
        <SingleFormLayout action='/api/app/warehouse/updateWarehouse' onSubmit={getData} sections={parsedFields} userPermissions={userPermissions} />
    )
}

export default MainWarehouse